import React, { useState } from 'react';
import { uploadImage } from '../services/api';

type ImageUploadProps = {
    onUploaded?: () => void | Promise<void>;
};

const ImageUpload: React.FC<ImageUploadProps> = ({ onUploaded }) => {
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [title, setTitle] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const [uploading, setUploading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<string | null>(null);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            setSelectedFile(event.target.files[0]);
        }
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            setError('Vælg venligst en fil til upload.');
            return;
        }

        setUploading(true);
        setError(null);
        setSuccess(null);

        try {
            const formData = new FormData();
            formData.append('image', selectedFile);
            formData.append('title', title);
            formData.append('description', description);
            await uploadImage(formData);
            setSuccess('Billedet blev uploadet!');
            setTitle('');
            setDescription('');
            setSelectedFile(null);
            if (onUploaded) {
                await onUploaded();
            }
        } catch (err) {
            setError('Fejl ved upload af billede. Prøv igen.');
        } finally {
            setUploading(false);
        }
    };

    return (
        <div>
            <input
                type="text"
                placeholder="Titel"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
            />
            <input
                type="text"
                placeholder="Beskrivelse"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
            />
            <input type="file" onChange={handleFileChange} />
            <button onClick={handleUpload} disabled={uploading}>
                {uploading ? 'Uploader...' : 'Upload'}
            </button>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            {success && <p style={{ color: 'green' }}>{success}</p>}
        </div>
    );
};

export default ImageUpload;